function getCurrentPath() {
    const hash = window.location.hash.replace(/^#/, "");
    if (hash) {
        const path = hash.split("?")[0];
        return path.startsWith("/") ? path : `/${path}`;
    }
    return window.location.pathname || "/";
}

function init() {
    global.xe.getCurrentPath = getCurrentPath;

    // 브라우저(UA) 체크 — 기기 종류 판별용
    global.xe.checkMobile = function () {
        if (
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        }
        return false;
    };

    // HEMS 모바일 전용 URL prefix
    global.xe.isHemsRoute = function (path) {
        const p = path || getCurrentPath();
        return p.startsWith("/hems") || p.startsWith("/mobile");
    };

    // API/메뉴 조회용 클라이언트 — HEMS URL에서만 Mobile, 그 외 항상 PC
    global.xe.getTargetClient = function () {
        return global.xe.isHemsRoute() ? "Mobile" : "PC";
    };
}

export { init };
